"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _SourceForm = require("./SourceForm");
Object.keys(_SourceForm).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _SourceForm[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _SourceForm[key];
    }
  });
});